import { Tabs } from 'antd';

import { Exclusions } from './Exclusions';
import { Identities } from './Identities';
import { ProductMatches } from './ProductMatches';

export const ProductTabs = () => (
  <Tabs
    size='large'
    items={[{
      key: '1',
      label: '1. Identities',
      children: <Identities />,
    }, {
      key: '2',
      label: '2. Exclusions',
      children: <Exclusions />,
    }, {
      key: '3',
      label: '3. Product Matches',
      children: <ProductMatches />,
    }]}
  />
);
